import React, { useState } from 'react';
import { Layout } from '../components/layout/Layout';
import { Calendar, User, ArrowRight, Clock } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogData';
const categories = ['All', 'Faith', 'Community', 'Devotional', 'Family', 'Scripture', 'Worship'];
export function BlogPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const filteredPosts = activeCategory === 'All' ? blogPosts : blogPosts.filter(post => post.category === activeCategory);
  const featuredPost = blogPosts.find(post => post.featured);
  const regularPosts = filteredPosts.filter(post => !post.featured || activeCategory !== 'All');
  return <Layout data-id="element-416">
      {/* Header */}
      <div className="bg-[#0A1F44] pt-44 md:pt-48 pb-20 text-center text-white relative overflow-hidden" data-id="element-417">
        <div className="absolute inset-0 opacity-20" data-id="element-418">
          <img src="https://images.unsplash.com/photo-1457369804613-52c61a468e7d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Background" className="w-full h-full object-cover" data-id="element-419" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F44] via-[#0A1F44]/70 to-[#0A1F44]" data-id="element-420" />
        <div className="container-custom relative z-10" data-id="element-421">
          <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4" data-id="element-422">
            Blog
          </h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-423">
            Insights, devotionals, and encouragement for your faith journey.
          </p>
        </div>
      </div>

      {/* Category Filter */}
      <div className="bg-white border-b sticky top-16 z-30" data-id="element-424">
        <div className="container-custom py-4" data-id="element-425">
          <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide" data-id="element-426">
            {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${activeCategory === category ? 'bg-[#0A1F44] text-white' : 'bg-[#F5F7FA] text-[#0A1F44] hover:bg-[#e2e8f0]'}`} data-id="element-427">
                {category}
              </button>)}
          </div>
        </div>
      </div>

      {/* Featured Post */}
      {activeCategory === 'All' && featuredPost && <section className="py-12 bg-[#F5F7FA]" data-id="element-428">
          <div className="container-custom" data-id="element-429">
            <motion.article initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="grid grid-cols-1 lg:grid-cols-2 gap-8 bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-430">
              <div className="relative h-64 lg:h-auto" data-id="element-431">
                <img src={featuredPost.image} alt={featuredPost.title} className="w-full h-full object-cover" data-id="element-432" />
                <div className="absolute top-4 left-4" data-id="element-433">
                  <span className="bg-[#fc0719] text-white px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider" data-id="element-434">
                    Featured
                  </span>
                </div>
              </div>
              <div className="p-8 md:p-12" data-id="element-435">
                <span className="bg-[#fc0719] text-white px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider" data-id="element-436">
                  Featured
                </span>
                <div className="flex items-center gap-4 text-sm text-gray-500 mb-4" data-id="element-437">
                  <span data-id="element-438">{featuredPost.date}</span>
                  <span data-id="element-439">•</span>
                  <span data-id="element-440">{featuredPost.category}</span>
                </div>
                <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#0A1F44] mb-4 hover:text-[#fc0719] transition-colors cursor-pointer" data-id="element-441">
                  {featuredPost.title}
                </h2>
                <p className="text-gray-600 text-lg mb-8 line-clamp-3" data-id="element-442">
                  {featuredPost.excerpt}
                </p>
                <Link to={`/blog/${featuredPost.id}`} className="inline-flex items-center text-[#0A1F44] font-semibold hover:text-[#fc0719] transition-colors group" data-id="element-443">
                  Read Full Article
                  <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-2 transition-transform" data-id="element-444" />
                </Link>
              </div>
            </motion.article>
          </div>
        </section>}

      {/* Regular Posts Grid */}
      <section className="py-16 bg-white" data-id="element-445">
        <div className="container-custom" data-id="element-446">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-447">
            {regularPosts.map((post, index) => <motion.article key={post.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow border border-gray-100 flex flex-col" data-id="element-448">
                <Link to={`/blog/${post.id}`} className="block relative h-48" data-id="element-449">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover" data-id="element-450" />
                  <div className="absolute top-4 left-4" data-id="element-451">
                    <span className="bg-white/90 backdrop-blur-sm text-[#0A1F44] px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider" data-id="element-452">
                      {post.category}
                    </span>
                  </div>
                </Link>
                <Link to={`/blog/${post.id}`} className="p-6 flex-1 flex flex-col block group" data-id="element-453">
                  <div className="flex-1" data-id="element-454">
                    <div className="text-sm text-[#fc0719] font-bold uppercase tracking-wider mb-2" data-id="element-455">
                      {post.category}
                    </div>
                    <h3 className="text-xl font-serif font-bold text-[#0A1F44] mb-3 group-hover:text-[#fc0719] transition-colors line-clamp-2" data-id="element-456">
                      {post.title}
                    </h3>
                    <p className="text-gray-600 mb-4 line-clamp-3 text-sm leading-relaxed" data-id="element-457">
                      {post.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-gray-500" data-id="element-458">
                      <span className="flex items-center gap-1" data-id="element-459">
                        <User className="w-3 h-3" data-id="element-460" />
                        {post.author}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-461">
                        <Calendar className="w-3 h-3" data-id="element-462" />
                        {post.date}
                      </span>
                    </div>
                  </div>
                </Link>
              </motion.article>)}
          </div>

          {/* Load More */}
          <div className="text-center mt-12" data-id="element-463">
            <button className="px-8 py-3 border-2 border-[#0A1F44] text-[#0A1F44] rounded-md font-medium hover:bg-[#0A1F44] hover:text-white transition-colors" data-id="element-464">
              Load More Articles
            </button>
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="py-16 bg-[#0A1F44]" data-id="element-465">
        <div className="container-custom text-center" data-id="element-466">
          <h2 className="text-3xl font-serif font-bold text-white mb-4" data-id="element-467">
            Stay Connected
          </h2>
          <p className="text-white/80 mb-8 max-w-xl mx-auto" data-id="element-468">
            Subscribe to our newsletter for weekly devotionals, church updates,
            and encouragement delivered straight to your inbox.
          </p>
          <div className="bg-[#0A1F44] p-8 md:p-12 rounded-3xl text-white flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-469">
            <div className="text-center md:text-left" data-id="element-470">
              <h2 className="text-2xl md:text-3xl font-serif font-bold mb-2" data-id="element-471">
                Subscribe to our Newsletter
              </h2>
              <p className="text-white/60" data-id="element-472">
                Get the latest articles and updates delivered to your inbox.
              </p>
            </div>
            <div className="flex w-full md:w-auto gap-4" data-id="element-473">
              <input type="email" placeholder="Your email" className="flex-1 px-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#fc0719] text-[#0A1F44]" data-id="element-474" />
              <button className="px-6 py-3 bg-[#fc0719] text-white rounded-md font-medium hover:bg-[#d4061a] transition-colors" data-id="element-475">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}